import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plano-acao-monitor',
  templateUrl: './plano-acao-monitor.component.html',
  styleUrls: ['./plano-acao-monitor.component.scss']
})
export class PlanoAcaoMonitorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}